import { toast } from "react-toastify";
import { PostActionType } from "../types/Types";
import { setIsPatchDeactivateEmployeeSuccess } from "../../modals/DeactivateEmployeeConfirmationModal/DeactivateEmployeeConfirmationModalSlice";
import { Dispatch } from "redux";

const getLocalTodayDateString = (): string => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
};

const formatLocalOutOfServiceDate = (outOfServiceDate: string): string => {
    const [year = "", month = "", day = ""] = outOfServiceDate.split("-");

    return `${day}-${month}-${year}`;
};

export const deactivateEmployee = async (
    employeeId: number,
    postEmployeeDeactivate: PostActionType,
    dispatch: Dispatch,
    establishmentId: number,
    outOfServiceDate: string,
): Promise<void> => {
    try {
        await postEmployeeDeactivate({
            id: employeeId,
            data: {
                establishment_id: establishmentId,
                out_of_service_date: outOfServiceDate,
            },
        }).unwrap();
        dispatch(setIsPatchDeactivateEmployeeSuccess(true));
        const staysVisibleUntil =
            outOfServiceDate > getLocalTodayDateString()
                ? `Medewerker blijft zichtbaar tot ${formatLocalOutOfServiceDate(outOfServiceDate)} en gaat dan uit dienst.`
                : "Medewerker is gedeactiveerd";
        toast.success(staysVisibleUntil);
    } catch (error) {
        console.error(error);
        toast.error(
            "Er is iets misgegaan bij het uit dienst nemen van de medewerker",
        );
    }
};
